export const getApiErrorMessage = (error) => {
  const detail = error?.response?.data?.detail;

  if (Array.isArray(detail)) {
    return detail
      .map((item) => {
        if (typeof item === 'string') return item;
        return item?.msg?.replace('Value error, ', '') || 'Invalid input.';
      })
      .join(', ');
  }

  if (typeof detail === 'string') {
    return detail;
  }

  if (typeof detail === 'object' && detail !== null) {
    return detail.msg || 'Invalid input.';
  }

  return error?.message || 'Something went wrong. Please try again.';
};